import React from 'react';

export type ComposerActivityKind = 'images' | 'voice';

export interface ComposerActivityTrayProps {
  kind: ComposerActivityKind;
  phase?: string;
  children: React.ReactNode;
}

export const ComposerActivityTray = ({
  kind,
  phase,
  children,
}: ComposerActivityTrayProps) => (
  <section
    className="command-centre-chat__activity-tray"
    data-activity={kind}
    data-phase={phase}
    data-testid="comms-composer-activity-tray"
  >
    {children}
  </section>
);
